import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TagModule } from 'primeng/tag';
import { TranslateModule } from '@ngx-translate/core';

import { ComponentsModule } from '../../components/components.module';
import { PipesModule } from '../../pipes/pipes.module';

import { TenantTransferComponent } from './tenant-transfer.component';
import { TransferObjectPickerComponent } from './transfer-object-picker/transfer-object-picker.component';
import { TransferReportComponent } from './transfer-report/transfer-report.component';

const cmp = [TenantTransferComponent, TransferObjectPickerComponent, TransferReportComponent];

@NgModule({
    declarations: [...cmp],
    imports: [
        CommonModule,
        FormsModule,
        ComponentsModule,
        PipesModule,
        TableModule,
        TabViewModule,
        DropdownModule,
        ButtonModule,
        InputTextModule,
        TagModule,
        TranslateModule
    ],
    exports: [...cmp]
})
export class TenantTransferModule {}
